export const INDUSTRIES = [
    {
        slug: "retail",
        name: "Retail",
        icon: "ShoppingBag",
        image: "https://images.unsplash.com/photo-1511317559916-56d5ddb62563?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxyZXRhaWwlMjBzdG9yZSUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzgyMzY2MTE5fDA&ixlib=rb-4.1.0&q=85",
        headline: "Composable retail experiences that convert and scale.",
        challenges: ["Monolithic commerce stacks blocking omnichannel innovation", "Inventory visibility gaps causing lost sales", "Slow experimentation and personalization velocity"],
        offerings: ["Composable commerce (MACH)", "Order & inventory intelligence", "Store technology & POS modernization", "Customer data platforms"],
        recommended_services: ["Product Engineering", "Data & AI", "Cloud & DevOps"],
        outcomes: ["Higher conversion", "Faster time to market", "Improved store & DC efficiency"],
        value_prop: "We build resilient retail platforms that survive peak season and evolve without replatform cycles.",
    },
    {
        slug: "bfsi",
        name: "BFSI",
        icon: "Landmark",
        image: "https://images.pexels.com/photos/6804071/pexels-photo-6804071.jpeg",
        headline: "Modernization and AI for banking, financial services, and insurance.",
        challenges: ["Aging cores and monolithic policy systems", "Fraud & risk model velocity", "Regulatory pressure on data governance"],
        offerings: ["Core modernization", "Fraud & risk analytics", "Digital banking platforms", "Wealth & insurance tech"],
        recommended_services: ["Product Engineering", "Data & AI", "Security", "Cloud & DevOps"],
        outcomes: ["Reduced fraud loss", "Faster product launches", "Regulatory readiness"],
        value_prop: "We modernize regulated systems without downtime, and put AI where the risk framework demands it.",
    },
    {
        slug: "logistics",
        name: "Logistics",
        icon: "Truck",
        image: "https://images.pexels.com/photos/12935042/pexels-photo-12935042.jpeg",
        headline: "Real-time visibility and route intelligence across supply chains.",
        challenges: ["Fragmented TMS/WMS visibility", "Rising last-mile costs", "SLA prediction accuracy"],
        offerings: ["Real-time visibility platforms", "Route optimization", "Warehouse automation", "Carrier & partner integration"],
        recommended_services: ["Data & AI", "Product Engineering", "Intelligent Automation"],
        outcomes: ["Lower last-mile cost", "Higher SLA attainment", "Fewer customer escalations"],
        value_prop: "We stitch fragmented supply chains into a single operating picture, with prescriptive routing baked in.",
    },
    {
        slug: "food-and-beverage",
        name: "Food & Beverage",
        icon: "UtensilsCrossed",
        image: "https://images.pexels.com/photos/262353/pexels-photo-262353.jpeg",
        headline: "Digital ordering, kitchen ops, and demand intelligence at scale.",
        challenges: ["Franchise-wide POS fragmentation", "Kitchen throughput bottlenecks", "Demand forecasting accuracy"],
        offerings: ["Digital ordering & loyalty", "Kitchen ops & KDS", "Demand forecasting", "Franchise analytics"],
        recommended_services: ["Product Engineering", "Data & AI", "Cloud & DevOps"],
        outcomes: ["Higher digital order share", "Improved kitchen efficiency", "Lower food waste"],
        value_prop: "We modernize QSR and F&B operations from the register to the supply chain — one system of record.",
    },
    {
        slug: "hospitality",
        name: "Hospitality",
        icon: "BedDouble",
        image: "https://images.unsplash.com/photo-1767416567191-baff01fc81ff",
        headline: "Guest experience platforms and revenue intelligence.",
        challenges: ["Fragmented guest data across PMS/CRM/loyalty", "Manual contact-center load", "Revenue leakage on distribution"],
        offerings: ["Guest experience platforms", "Conversational AI concierges", "Revenue & pricing intelligence", "Property tech modernization"],
        recommended_services: ["Data & AI", "Product Engineering", "Intelligent Automation"],
        outcomes: ["Higher NPS", "Improved RevPAR", "Lower contact-center cost"],
        value_prop: "We turn the guest journey into a unified digital experience — with revenue intelligence to match.",
    },
    {
        slug: "energy-and-utilities",
        name: "Energy & Utilities",
        icon: "Zap",
        image: "https://images.pexels.com/photos/5480781/pexels-photo-5480781.jpeg",
        headline: "Grid analytics, DER integration, and asset intelligence.",
        challenges: ["Peak load management with renewables", "Aging OT/IT integration", "Regulatory reporting overhead"],
        offerings: ["Grid analytics", "DER integration", "Asset performance management", "Regulatory reporting automation"],
        recommended_services: ["Data & AI", "Cloud & DevOps", "Intelligent Automation"],
        outcomes: ["Better peak dispatch", "Lower unplanned outages", "Faster compliance cycles"],
        value_prop: "We help utilities operationalize data to run a smarter, cleaner grid.",
    },
    {
        slug: "manufacturing",
        name: "Manufacturing",
        icon: "Factory",
        image: "https://images.pexels.com/photos/37730212/pexels-photo-37730212.jpeg",
        headline: "Smart factory, OEE uplift, and digital twin engineering.",
        challenges: ["Fragmented MES and plant-level data", "Unplanned downtime cost", "Slow ramp on new product introductions"],
        offerings: ["IIoT & digital twin", "OEE analytics", "Predictive maintenance", "MES modernization"],
        recommended_services: ["Data & AI", "Cloud & DevOps", "Intelligent Automation"],
        outcomes: ["OEE improvement", "Reduced unplanned downtime", "Faster NPI cycles"],
        value_prop: "We deliver measurable OEE uplift and predictive maintenance across plant footprints.",
    },
    {
        slug: "startups-and-consulting",
        name: "Startups & Consulting",
        icon: "Sparkles",
        image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxzb2Z0d2FyZSUyMGVuZ2luZWVyaW5nJTIwdGVhbSUyMGNvbGxhYm9yYXRpbmclMjBvZmZpY2V8ZW58MHx8fHwxNzgyMDgxNTEyfDA&ixlib=rb-4.1.0&q=85",
        headline: "MVP-to-scale engineering partner for founders and boutique consulting firms.",
        challenges: ["Series A shipping pressure", "Founder-led engineering bandwidth", "Consulting firms needing white-labeled delivery"],
        offerings: ["MVP acceleration pods", "Founding-team augmentation", "White-labeled delivery for consulting firms", "Investor-ready architecture reviews"],
        recommended_services: ["Product Engineering", "Data & AI", "Cloud & DevOps"],
        outcomes: ["Faster funding milestones", "Reduced founder engineering load", "Higher delivery leverage for consultants"],
        value_prop: "We ship product with founders, and we quietly power delivery for the world's best boutique consulting firms.",
    },
];

export function getIndustryBySlug(slug) {
    return INDUSTRIES.find((i) => i.slug === slug);
}
